import { useState } from "react"

import { ArrowDown, ArrowUp, ArrowUpDown, Filter, X } from "lucide-react"

import { Button } from "@ui/button"
import { Input } from "@ui/input"
import { Popover, PopoverContent, PopoverTrigger } from "@ui/popover"

const getSortIcon = (sortDirection: string | false) => {
    if (sortDirection === "asc") {
        return <ArrowUp className="h-4 w-4" />
    } else if (sortDirection === "desc") {
        return <ArrowDown className="h-4 w-4" />
    }
    return <ArrowUpDown className="h-4 w-4" />
}

interface ColumnFilterProps {
    column: any
    label: string
    hideSort?: boolean
    hideFilter?: boolean
}
export function ColumnFilter({ column, label, hideSort = false, hideFilter = false }: Readonly<ColumnFilterProps>) {
    const [filterValue, setFilterValue] = useState(column.getFilterValue() || "")
    const isFiltered = filterValue || column.getFilterValue()

    const keyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            column.setFilterValue(filterValue)
        }
    }

    return (
        <div className="flex items-center gap-2">
            <div className='font-semibold truncate'>
                {label}
            </div>
            <div className="flex items-center gap-2">
                {
                    !hideSort &&
                    <Button
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                        variant="ghost"
                        size="icon"
                    >
                        {getSortIcon(column.getIsSorted())}
                    </Button>
                }
                {
                    !hideFilter &&
                    <Popover>
                        <PopoverTrigger asChild>
                            <div
                                className={`h-[25px] w-[25px] inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-gray-200 ${isFiltered ? "bg-gray-300 text-white" : ""} cursor-pointer`}
                            >
                                <Filter className="h-4 w-4" />
                            </div>
                        </PopoverTrigger>
                        <PopoverContent side="top" align="end" className="flex flex-row gap-1 p-1 bg-white text-primary-dark">
                            <Input
                                placeholder={`Filter ${label}s...`}
                                value={filterValue}
                                onChange={e => setFilterValue(e.target.value)}
                                onKeyDown={keyPress}
                            />
                            <Button
                                variant="outline"
                                onClick={() => {
                                    setFilterValue("")
                                    column.setFilterValue("")
                                }}
                                className='hover:opacity-75'
                            >
                                <X className="h-4 w-4" />
                            </Button>
                        </PopoverContent>
                    </Popover>
                }
            </div>
        </div>
    )
}